module.exports = __webpack_public_path__ + "static/media/kitchen-scheme-light.a91b2f70.jpeg";